/**
 * device 関数
 **/
(function($) {
  var ua = navigator.userAgent;
  var iphone = ua.indexOf('iPhone') > 0;
  var androidSp = ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0;
  var ipad = ua.indexOf('iPad') > 0;
  var androidT = ua.indexOf('Android') && !ua.indexOf('Mobile') ;

  /*
  console.log( 'ua', ua );
  console.log( 'iphone', iphone );
  console.log( 'androidSp', androidSp );
  console.log( 'ipad', ipad );
  console.log( 'androidT', androidT );
  */

  $.device = {
    isMobile : function() {
      return iphone || androidSp;
    },
    isTablet : function() {
      return ipad || androidT;
    },
    isMobileOrTablet : function() {
      return this.isMobile() || this.isTablet();
    },
    isPc : function() {
      return !(this.isMobileOrTablet());
    },
    isIOS : function() {
      return iphone || ipad;
    },
    isAndroid : function() {
      return androidSp || androidT;
    }
  };
})(jQuery);
